export default "__VITE_ASSET__DL_duf_L__"